module.exports = __webpack_public_path__ + "img/mayoristas.d2e48b60.png";